import React from 'react';
import * as S from './Loader.styles';

const Loader = ({props}) => {
    return(
        <S.LoaderMainWrap>
            <S.LoaderMainInnerWrap margin={props.margin}>
                <S.LoaderDiv/>
            </S.LoaderMainInnerWrap>
        </S.LoaderMainWrap>
        
    )
}

export default Loader;